import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_home_decor_storage: FaireCategoryEntity = {
  token: "cat_home-decor-storage",
  type: "category",
  name: "Storage & organization",
  level: 2,
  parentToken: "cat_home-decor",
  href: "/category/home-decor/storage-organization",
  childCategoryTokens: [
    "cat_storage-all",
    "cat_storage-baskets",
    "cat_storage-desk",
    "cat_storage-laundry",
    "cat_storage-racks",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
